import PropTypes from 'prop-types'
import React from 'react'
import styled, { css } from 'styled-components'

import { Text } from '.'
import { dimensions, light, spacing } from '../../constants/theme'
import { ImageIcon } from '../ImageIcon'

const StyledAlert = styled.div`
  width: 100%;
  display: flex;
  border-radius: ${dimensions.borderRadiusSM};
  padding: ${spacing.spacingLG};
  align-items: center;
  flex-shrink: 0;
  margin: ${spacing.spacingMD} 0;
  ${({ type }) => {
    if (type === 'warning') {
      return css`
        & > p {
          color: ${light.red300};
        }
        background-color: ${light.redAlert};
        border: 1px solid ${light.red200};
        border-left: 4px solid ${light.red200};
      `
    }
    if (type === 'success') {
      return css`
        & > p {
          color: ${light.green200};
        }
        background-color: ${light.greenAlert};
        border: 1px solid ${light.green200};
        border-left: 4px solid ${light.green200};
      `
    }
    if (type === 'primary') {
      return css`
        & > P {
          color: ${light.primary};
        }
        background-color: ${light.focus};
        border: 1px solid ${light.primary};
        border-left: 4px solid ${light.primary};
      `
    }
    if (type === 'neutral') {
      return css`
        & > P {
          color: ${light.dark800};
        }
        background-color: ${light.gray300};
        border: 1px solid ${light.dark700};
        border-left: 4px solid ${light.dark700};
      `
    }
  }}
`

const Alert = ({ children, icon, type }) => {
  return (
    <StyledAlert type={type}>
      <ImageIcon
        marginRight="8"
        flexShrink="0"
        width="24"
        height="24"
        icon={icon}
      />
      <Text size="bSmall" text={children} />
    </StyledAlert>
  )
}

Alert.propTypes = {
  children: PropTypes.string,
  icon: PropTypes.string,
  type: PropTypes.string,
}

Alert.defaultProps = {
  icon: '',
  children: 'This is alert text, how neat!',
  type: 'warning',
}

export { Alert }
